export default __webpack_public_path__ + "static/media/rebalance-history-active.2c07178d.svg";